var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('pdf',{attrs:{"value":_vm.output,"icon":_vm.icon,"fileName":_vm.fileName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }